import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../../redux/actions/irSearch';
import EmailFormPopup from './EmailFormPopup';


class EmailPartPopup extends Component {
  onSubmit = (params) => {
    this.props.dispatch(irActions.sendEmail(params))
      .then(this.props.reloadDetails);
  }

  render() {
    return (
      <EmailFormPopup {...this.props} onSubmit={this.onSubmit} />
    );
  }
}

EmailPartPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  favoriteEmail: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailPartPopup);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/popups/EmailPartPopup.jsx
 **/